import Swiper from 'swiper';
import {Navigation, Pagination} from 'swiper/modules';
import 'swiper/swiper-bundle.css';

// init logo slider with swiper
const initLogoSlider = () => {
    new Swiper(".tt-logo-slider .swiper-logo-slider", {
        modules: [Navigation, Pagination],
        slidesPerView: 1,
        spaceBetween: 24,
        slidesPerGroup: 1,
        loop: false,
        loopFillGroupWithBlank: true,

        // pagination bullets
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },

        // navigation arrows
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },

        // responsive breakpoints
        breakpoints: {
            768: {
                slidesPerView: 2,
            },
            1024: {
                slidesPerView: 3,
            },
            1200: {
                slidesPerView: 4,
            },
        }
    });
}

export default initLogoSlider;
